import { render, staticRenderFns } from "./EventTypesGroup.vue?vue&type=template&id=6ab78e48&"
import script from "./EventTypesGroup.vue?vue&type=script&lang=ts&"
export * from "./EventTypesGroup.vue?vue&type=script&lang=ts&"
import style0 from "./EventTypesGroup.vue?vue&type=style&index=0&id=6ab78e48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports